import type { ParamMatcher } from '@sveltejs/kit';
import type { AssetTypeIdentifier } from '$types/assetTypeIdentifier';

const SUPPORTED_WITHDRAW_ASSETS = ['eure', 'gbpe', 'usdc', 'gno'];

export const match: ParamMatcher = (param): param is AssetTypeIdentifier => {
  return SUPPORTED_WITHDRAW_ASSETS.includes(param);
};
